import { PayrollTypeEnum } from "./payroll-type.enum";

export class PayslipGenerationReq{
    employeeId?: any;
    month?: number;
    employeeType?:PayrollTypeEnum;
    year?: number;
    employeeMode?:string;
    employeeCategory?: string;
    empcode?:string;
    empmbl?:number;

    constructor(employeeId?: any,month?: number,employeeType?:PayrollTypeEnum,year?: number,employeeMode?:string,employeeCategory?: string,empcode?:string,empmbl?:number){
        this.employeeId = employeeId
        this.month = month
        this.employeeType = employeeType
        this.year = year
        this.employeeMode = employeeMode
        this.employeeCategory = employeeCategory
        this.empcode=empcode
        this.empmbl=empmbl
    }
}